import { WalletPaymentMethodInfoBase } from './wallet-payment-method-info-base';

export interface ApplePayInfo extends WalletPaymentMethodInfoBase {
  type: 'APPLE_PAY';
}
